import PortfolioReducer from "./portfolio/reducer";
import CandidateUserReducer from "./candidate-user/reducer";

export { PortfolioReducer, CandidateUserReducer };
